module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "teamMember",
    on: {
      "click": function($event) {
        return _vm.showMoreInfo()
      }
    }
  }, [_c('div', {
    staticClass: "teamMemberImg"
  }, [(_vm.picture != '') ? _c('img', {
    staticClass: "fillImg",
    attrs: {
      "alt": _vm.memberName,
      "src": _vm.picture
    }
  }) : _vm._e()]), _vm._v(" "), _c('h4', [_c('strong', [_vm._v(_vm._s(_vm.memberName))]), _vm._v(", " + _vm._s(_vm.title))]), _vm._v(" "), (_vm.info != '') ? _c('span', {
    staticClass: "memberReadMore"
  }, [_vm._v("קראו עוד>")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2616d1e2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TeamMember.vue
// module id = 107
// module chunks = 0